<template>
  <v-dialog v-model="dialog" max-width="400">
    <v-card>
      <v-card-title class="headline">Migration PAL</v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item class="step-item" v-for="step in steps" :key="step.id">
            <v-list-item-content>
              <v-list-item-title>{{ step.step }}</v-list-item-title>
              <v-list-item-subtitle>
                {{ getFormatDate(step.updated_at) }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-icon>
              <v-tooltip bottom color="white">
                <template v-slot:activator="{ on }">
                  <v-icon
                    right
                    :color="StepsStatusColorsMap[step.status]"
                    v-on="on"
                  >
                    {{ StepsStatusIconsMap[step.status] }}
                  </v-icon>
                </template>
                <span class="black--text">
                  {{ StepsStatusLabelsMap[step.status] }}
                </span>
              </v-tooltip>
            </v-list-item-icon>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="error" @click="close">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from 'lodash';
import { StepsStatusesMap, StepsList } from '@/constants';
import { DateTimeFormatter } from '@/shared/DateTime.formatter';

const StepsStatusLabelsMap = {
  [StepsStatusesMap.PENDING]: 'Pending',
  [StepsStatusesMap.IN_PROGRESS]: 'In progress',
  [StepsStatusesMap.COMPLETED]: 'Completed',
  [StepsStatusesMap.SIGNED]: 'Signed'
};
const StepsStatusIconsMap = {
  [StepsStatusesMap.PENDING]: 'mdi-av-timer',
  [StepsStatusesMap.IN_PROGRESS]: 'mdi-chevron-triple-right',
  [StepsStatusesMap.COMPLETED]: 'mdi-check',
  [StepsStatusesMap.SIGNED]: 'mdi-check-all'
};
const StepsStatusColorsMap = {
  [StepsStatusesMap.PENDING]: 'warning',
  [StepsStatusesMap.IN_PROGRESS]: 'primary',
  [StepsStatusesMap.COMPLETED]: 'success',
  [StepsStatusesMap.SIGNED]: 'success'
};

export default {
  data() {
    return {
      StepsStatusLabelsMap,
      StepsStatusIconsMap,
      StepsStatusColorsMap,
      dialog: false,
      steps: [],
      completedStepsAmount: 0,
      signedStepsAmount: 0
    };
  },
  methods: {
    open(migrationPollSteps) {
      this.dialog = true;
      this.steps = _.unionBy(migrationPollSteps, StepsList, 'step');
    },
    close() {
      this.dialog = false;
    },
    getFormatDate(date) {
      return DateTimeFormatter.formatWithTime(date);
    }
  }
};
</script>

<style lang="scss">
.step-item {
  &:nth-of-type(odd) {
    background-color: #eeeeee;
  }
}
</style>
